import * as actionTypes from "../actionTypes";

const initialState = {
    testimonialData: [],
};

const testimonialsReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_TESTIMONIALS: {
            return {
                ...state,
                testimonialData: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default testimonialsReducer;
